import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { CarouselModule, MediaModule, OutletModule } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SharedModule } from 'src/app/shared/shared.module';
import { ShimanoProductImagesComponent } from './shimano-product-images.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MediaModule,
    OutletModule,
    SlickCarouselModule,
    CarouselModule,
    SharedModule,
    ShimanoProductImagesComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductImagesComponent: {
          component: ShimanoProductImagesComponent,
        },
      },
    }),
  ],
  exports: [ShimanoProductImagesComponent],
})
export class ShimanoProductImagesModule {}
